<script>
	import { Router, Link, Route } from "svelte-navigator";
	import DefaultLayout from './routes/layouts/default.svelte';
	import InnerLayout from './routes/layouts/inner.svelte';
	import InnerBoxLayout from './routes/layouts/inner-box.svelte';
	import Home from './routes/index.svelte';
	import PrivacyPolicy from './routes/privacy-policy.svelte';
	import TermsOfUse from './routes/terms-of-use.svelte';
	import RefundPolicy from './routes/refund-policy.svelte';
	import ShippingDelivery from './routes/shipping-and-delivery.svelte';
	import MetricWeightMeasures from './routes/metric-weight-measures.svelte';
	import FoodSafetySanitation from './routes/foodsafety-sanitation.svelte';
	import ContactUs from './routes/contactus.svelte';
	import AboutUS from './routes/aboutus.svelte';
	import ProductPage from './routes/products/details.svelte';
	import CheckoutPage from './routes/checkout.svelte';
	import OrderDetails from "./routes/order_details.svelte";
	import Toast from "./lib/components/Toast.svelte";
	import { init, track } from 'fbq';
	import AllProducts from './routes/all_products.svelte';
	import ComingSoon from "./routes/coming-soon.svelte";
	import WriteReview from "./routes/write-review.svelte";
	import SearchResults from "./routes/SearchResults.svelte";
  	import MobileNumber from "./routes/mobileNumber.svelte";
 
	const pixel = '177839467631190';
	
	init(pixel)
	track('PageView')

</script>
<Router>
	<Route path="/">
		<DefaultLayout>
			<Home/>
		</DefaultLayout>
	</Route>
	<Route path="privacy-policy">
		<InnerLayout>
			<PrivacyPolicy/>
		</InnerLayout>
	</Route>
	<Route path="aboutus">
		<InnerLayout>
			<AboutUS />
		</InnerLayout>
	</Route>
	<Route path="termsofuse">
		<InnerLayout>
			<TermsOfUse />
		</InnerLayout>
	</Route>
	<Route path="refund-policy">
		<InnerLayout>
			<RefundPolicy />
		</InnerLayout>
	</Route>
	<Route path="shipping-and-delivery">
		<InnerLayout>
			<ShippingDelivery />
		</InnerLayout>
	</Route>
	<Route path="metric-weight-measures">
		<InnerLayout>
			<MetricWeightMeasures />
		</InnerLayout>
	</Route>
	<Route path="foodsafety-sanitation">
		<InnerLayout>
			<FoodSafetySanitation />
		</InnerLayout>
	</Route>
	<Route path="contactus">
		<InnerBoxLayout>
			<span slot="heading">Contact Us</span>
			<ContactUs />
		</InnerBoxLayout>
	</Route>
	<Route path="/products/:id" let:params>
		<InnerLayout>
			<ProductPage id={params.id}/>
		</InnerLayout>
	</Route>
	<Route path="/checkout">
		<InnerBoxLayout>
			<span slot="heading">Checkout</span>
			<CheckoutPage/>
		</InnerBoxLayout>
	</Route>
	<Route path="/order/:id" let:params>
		<InnerBoxLayout>
			<span slot="heading">Order</span>
			<OrderDetails id={params.id}/>
		</InnerBoxLayout>
	</Route>
	<Route path="/review/:id" let:params>
		<InnerBoxLayout>
			<span slot="heading">Review</span>
			<WriteReview id={params.id}/>
		</InnerBoxLayout>
	</Route>
	<Route path="/search/:query" let:params>
		<DefaultLayout searchQuery={params.query}>
			<AllProducts query={params.query} title="Search results"/>
		</DefaultLayout>
	</Route>
	<Route path="/cat/:id" let:params>
		<DefaultLayout>
			<AllProducts cat={params.id}/>
		</DefaultLayout>
	</Route>
	<Route path="/celebration-cakes">
		<DefaultLayout>
			<AllProducts title="Premium Celebration Cakes"/>
		</DefaultLayout>
	</Route>
	<Route path="/brownies">
		<DefaultLayout>
			<AllProducts cat="4" title="Brownies" />
		</DefaultLayout>
	</Route>
	<Route path="/turkish">
		<DefaultLayout>
			<AllProducts cat="5" title="Turkish Blondies" />
		</DefaultLayout>
	</Route>
	<Route path="/coming-soon">
		<DefaultLayout>
			<ComingSoon />
		</DefaultLayout>
	</Route>
	<Route path="/search-results">
		<DefaultLayout darkheader>
			<SearchResults />
		</DefaultLayout>
	</Route>
	<Route path="/enter-mobile-number">
		<DefaultLayout darkheader>
			<MobileNumber />
		</DefaultLayout>
	</Route>
</Router>
<Toast/>